import{jsxs as e,jsx as o}from"react/jsx-runtime";import t from"tailwind-styled-components";import s from"clsx";const r=t.div`
  drop-shadow
  flex-shrink-0
  inline-flex
  items-center
  justify-center
  relative
  transform-gpu
`,l=t.img`
  rounded-full
  w-auto
  h-full
`,a=t.img`
  bg-white
  absolute
  bottom-0
  right-0
  rounded-full
  shadow
  w-auto
  h-5
`,i=({asset:t,className:i,hideNetwork:n=!1,size:c="normal",...d})=>{const m=!["ethereum","stellar","bitcoin","litecoin"].includes(t.protocol)&&t.protocol!==t.servicePath&&!n,p=s(i,{"w-4 h-4":"small"===c,"w-9 h-9":"normal"===c,"w-12 h-12":"large"===c,"w-16 h-16":"xlarge"===c,"rounded-full bg-white":!["terrausd","bscwrappedust","enjin"].includes(t.protocol),"rounded-none bg-transparent":["terrausd","bscwrappedust","enjin"].includes(t.protocol),"p-1":["axieinfinity","bat","bscaxieinfinity","bscbusd","bsccardano","bscdai","bscsmoothlovepotion","cryptofranc","maker","dai","paxosgold","smoothlovepotion","testbscbusd"].includes(t.protocol)}),u=s({"w-2 h-2":"small"===c,"w-4 h-4":"normal"===c,"w-5 h-5":"large"===c,"w-7 h-7":"xlarge"===c});return e(r,{className:p,...d,children:[o(l,{alt:`${t.displayName} Logo`,role:"img",src:`https://assets.bidali.com/currencies/${t.protocol}.png`}),m&&o(a,{alt:t.network.name,className:u,role:"network-img",src:`https://assets.bidali.com/networks/small/${t.servicePath}.png`})]})};export{i as default};
